module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "eve-of-warfare-8.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Praise for Sylvia Day")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“You know you’re in for a good book when other authors—and I mean LOTS of other authors—recommend it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—USA Today")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“A page-turner!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Access Hollywood Live")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“Glamorous people, swanky settings, steamy sex, and passionate married love make this a heartwarming, gratifying conclusion to the series.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“[A] highly charged story that flows and hits the mark.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“Will have you furiously flipping pages.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Glamour")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“Sophisticated, engaging, clever and sweet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—The Irish Independent")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“Superb writing . . . I can’t wait to see what Day does next!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—RT Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“When it comes to brewing up scorchingly hot sexual chemistry, Day has few literary rivals.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“Day writes indulgent fantasy at its most enjoyable, in a story populated by high-society beauties and rakes, all of them hiding dark passions and darker secrets behind their glittering facades.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Shelf Awareness")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("“This bold, erotic tale of passion and revenge features a cast of colorful characters and a complex and intriguing plot.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("—Library Journal")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c83bf8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eveofwarfarepraise.vue
// module id = 57
// module chunks = 0